<template>
  <div class="w-full">
    <div class="py-10 w-full px-6">
      <h1 class="font-bold text-gray-900 text-3xl mb-6">Bibliothek aller Contentmodule </h1>
      <section v-if="superAdmin" class="">
        <div class="card">
          <div class="card-header">
            <p class="card-header-title">Super Admin Toolbox</p>
          </div>
          <div class="card-content">
                <b-message 
                  b-message type="is-danger" has-icon>
                  Sie sind Super Admin! Ihnen stehen zusätzliche Funktionen zur Verfügung!    
                </b-message>
              </div>
          
            <footer class="card-footer">
              <!--  <a href="#" class="card-footer-item" @click="isComponentModalActive = true" >Erstelle ein Modul</a> -->
      <b-button
        class="card-footer-item collapse-padding"
          label="Erstelle ein Modul"
          type="is-primary is-light"
          size="is-medium"
          @click="isComponentModalActive = true" 
          />
<!-- New PDF UPLOAD to BACKEND -->
      <pdf-summarizer></pdf-summarizer>
    </footer>
    </div>
    <br>
  </section>
      <div class="flex flex-col lg:flex-row w-full lg:items-center lg:w-2/3 sticky-modal">
    <b-modal
      v-model="isComponentModalActive"
      has-modal-card
      full-screen
      :can-cancel="false"
      @close="closeModal"
    >
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Erstelle Content Modul</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Module Name">
            <b-input
              type="text"
              v-model="formData.name"
              placeholder="Module Name"
              required
            ></b-input>
          </b-field>
          <section>
              <b-field>
                <b-switch v-model="isWebinar">Webinar</b-switch>
              </b-field>
              <div v-if="isWebinar">
                <b-field label="Webinar URL">
                  <b-input v-model="formData.iFrame_URL" placeholder="Enter Webinar URL" :required="isWebinar"></b-input>
                </b-field>
              </div>
            </section>
          <b-field label="Description">
            <b-input
              type="textarea"
              v-model="formData.description"
              placeholder="Description"
              required
            ></b-input>
          </b-field>
          <b-field label="Modul Kategorie">
            <b-select v-model="formData.module_category" placeholder="Select Modul Category" required>
            <option v-for="category in moduleCategories" :key="category.id" :value="category">
              {{ category.name }}
            </option>
          </b-select>
          </b-field>
          <b-field label="Media">
          <b-select v-model="formData.media" placeholder="Select Media" :required="!isWebinar">
            <option v-for="media in mediaOptions" :key="media.id" :value="media">{{ media.File.name }}</option>
          </b-select>
        </b-field>
        <b-message v-if="!isWebinar" type="is-warning">
          Bitte füge eine Datei (Media) an! Diese Datei ist für normale Content Module wichtig! Für Webinare ist es optional!
        </b-message>
          <b-field label="Lizenz">
            <b-tooltip 
              label="Dieser Inhalt enthält Lizenzen Dritter?"
              position="is-right">
              <b-checkbox v-model="formData.licence">Lizenzfrei</b-checkbox>
            </b-tooltip>
          </b-field>
          <section>
            <b-field>
              <b-switch v-model="switchStates.CC_0">CC_0</b-switch>
            </b-field>
            <b-field>
              <b-switch v-model="switchStates.CC_BY">CC_BY</b-switch>
            </b-field>
            <b-field>
              <b-switch v-model="switchStates.CC_NC">CC_NC</b-switch>
            </b-field>
            <b-field>
              <b-switch v-model="switchStates.CC_ND">CC_ND</b-switch>
            </b-field>
            <b-field>
              <b-switch v-model="switchStates.CC_SA">CC_SA</b-switch>
            </b-field>
            <!-- <button @click="getSelectedCCValues">Log Selected Values</button> -->
          </section>
          <!-- <b-field label="JSON 1">
            <b-input
              type="textarea"
              v-model="formData.CC"
              placeholder="Enter JSON 1"
              required
            ></b-input>
          </b-field> -->
          <section>
            <b-field label="Subkategorien hinzufügen">
              <b-taginput
                v-model="module_subcategory"
                :data="filteredTags"
                :allow-new="allowNew"
                autocomplete
                maxtags="5"
                type="is-info"
                icon="label"
                placeholder="Add a tag"
                :open-on-focus="openOnFocus"
                field="key"
                aria-close-label="Delete this tag"
                @typing="getFilteredTags"
                >
              </b-taginput>
            </b-field>
            <!-- <p class="content"><b>Tags:</b> {{ module_subcategory }}</p> -->
            <!-- <button @click="submitForm">Submit Form</button> -->
          </section>
          <!-- <b-field label="JSON 2">
            <b-input
              type="textarea"
              v-model="formData.module_subcategory"
              placeholder="Enter JSON 2"
              required
            ></b-input>
          </b-field> -->
        </section>
        <footer class="modal-card-foot">
          <b-button label="Close" @click="closeModal"></b-button>
          <b-button label="Erstellen" type="is-primary" @click="createModule"></b-button>
        </footer>
      </div>
    </b-modal>
<!-- Search Section -->
    <!--      <div class="w-full relative mb-4 lg:mb-0 lg:mr-4 lg:w-1/3">
          <div class="absolute text-gray-600 flex items-center pl-3 h-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon icon-tabler icon-tabler-search"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" />
              <circle cx="10" cy="10" r="7" />
              <line x1="21" y1="21" x2="15" y2="15" />
            </svg>
          </div>
          <label for="search" class="hidden"></label>
          <input
            id="search"
            class="bg-gray-100 text-gray-600 focus:outline-none focus:border focus:border-blue-700 font-normal w-full h-10 flex items-center pl-10 text-sm border-gray-300 rounded border"
            placeholder="Search"
          />
        </div>
        <div class="relative w-full lg:w-1/4 mb-4 lg:mb-0 lg:mr-3 z-10">
          <div class="absolute z-0 inset-0 m-auto mr-2 xl:mr-4 z-0 w-5 h-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon cursor-pointer icon-tabler icon-tabler-chevron-down"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="#a0aec0"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" />
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </div>
          <select
            aria-label="Selected tab"
            class="relative z-10 cursor-pointer focus:outline-none focus:border-gray-800 focus:shadow-outline-gray text-sm form-select block w-full py-2 px-2 xl:px-3 border border-gray-300 rounded text-gray-600 appearance-none bg-transparent"
          >
            <option class="text-sm text-gray-600">Headers and Titles</option>
            <option class="text-sm text-gray-600">Authors and Tutors</option>
            <option selected class="text-sm text-gray-600">
              Topics & Skills
            </option>
          </select>
        </div>
        <div class="relative w-full lg:w-1/4 mb-4 lg:mb-0 lg:mr-3 z-10">
          <div class="z-0 absolute inset-0 m-auto mr-2 xl:mr-4 z-0 w-5 h-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon cursor-pointer icon-tabler icon-tabler-chevron-down"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="#a0aec0"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" />
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </div>
          <select
            aria-label="Selected tab"
            class="relative z-10 cursor-pointer focus:outline-none focus:border-gray-800 focus:shadow-outline-gray text-sm form-select block w-full py-2 px-2 xl:px-3 border border-gray-300 rounded text-gray-600 appearance-none bg-transparent"
          >
            <option class="text-sm text-gray-600">Name</option>
            <option class="text-sm text-gray-600">Size</option>
            <option selected class="text-sm text-gray-600">Duration</option>
          </select>
        </div>
         <div
          class="relative w-full lg:w-1/4 cursor-pointer z-0 border focus:border-gray-800 border-gray-300 rounded p-2"
        >
          <div
            class="z-0 w-10 pl-2 absolute inset-0 m-auto z-0 mr-0 flex items-center text-gray-600"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon cursor-pointer icon-tabler icon-tabler-calendar-event"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" />
              <rect x="4" y="5" width="16" height="16" rx="2" />
              <line x1="16" y1="3" x2="16" y2="7" />
              <line x1="8" y1="3" x2="8" y2="7" />
              <line x1="4" y1="11" x2="20" y2="11" />
              <rect x="8" y="15" width="2" height="2" />
            </svg>
            <input
              type="date"
              class="absolute right-0 z-10 opacity-0 cursor-pointer"
            />
          </div>
          <p class="text-sm text-gray-600">By Dates</p>
        </div>-->
    </div> 
<!-- Menue Filter Category BEGIN -->
<div>
  <b-navbar v-if="!isMobile" :class="{ 'sticky-container': stickyContainer }">
    <template #start>
      <b-navbar-item @click="toggleStickyContainer">
        <div class="tile collapse-padding "> 
          <b-message b-message :type="stickyContainer ? 'is-success' : 'is-info'">
            Filter für schnelle Navigation 
          </b-message>
        </div>
        </b-navbar-item>
        </template> 
        <template #end>
            <div 
              v-for="moduleCategory in filteredModuleCategories"
              :key="moduleCategory.name"
              class="tag-container"
              @click="scrollToSection(moduleCategory.name)"
            >
            <b-tag rounded size="is-medium" class="tag-item">{{ moduleCategory.name }}</b-tag>
            <div
              class="container px-2 py-2"
              v-if="moduleCategory.module_subcategory"
            >
              <b-field grouped>
                <div v-for="module_subcategory in mod.module_subcategory" :key="module_subcategory.id" class="control mt-2">             
                  <span>                       
                      <b-tag rounded size="is-medium" class="tag-item">{{ module_subcategory.key }}</b-tag>             
                  </span>
                </div>
              </b-field>
            </div>
          </div>          
        </template>
  </b-navbar>
      <!-- Show only module subcategories for mobile view -->
      <div class="tile is-4 is-vertical is-parent" v-else>
      <div 
        v-for="moduleCategory in filteredModuleCategories"
        :key="moduleCategory.name"
        class="tag-container container px-1 py-1"
        @click="scrollToSection(moduleCategory.name)"
      >
       
          <b-tag rounded size="is-medium" class="tag-item">{{ moduleCategory.name }}</b-tag>
          <div class="container px-2 py-2">
            <b-field grouped>
      <div v-for="(module) in moduleCategory.modules" :key="module.id" class="control mt-2">
        <div v-for="(subCategory) in module.module_subcategory" :key="subCategory.id">
          <!-- {{ moduleIndex + 1 }}.{{ subCategory.key }}          -->
          <span>
            <b-taglist attached>
              <b-tag rounded size="is-medium" class="tag-item">{{ subCategory.key.key }}</b-tag>
            </b-taglist>
          </span>
        </div>
      </div>
    </b-field>
          </div>
        
      </div>
    </div>
<!-- Menue Filter Category END -->
<!-- Modul Category BEGIN -->
    <section>
      <b-collapse
        v-for="(moduleCategory, index) in filteredModuleCategories" 
        :key="moduleCategory.name"
        animation="slide"
        :open="isOpenCategory == index"
        @open="isOpenCategory = index"
        class="collapse-padding"
        :id="moduleCategory.name"
      >
      <template #trigger="props">
        <div
          class="card-header"
          role="button"
          :aria-controls="'contentIdForA11y5-' + index"
          :aria-expanded="props.open"
        >
      <h3 v-if="moduleCategory.name === 'Tutorial'" class="font-medium text-left text-gray-900 mt-8 mb-6">
      </h3>
      <h3 v-else class="card-header-title font-bold border-b-4 text-gray-900 mt-8">
        {{ moduleCategory.name }} ( {{ moduleCount(moduleCategory).selected }} von {{ moduleCount(moduleCategory).total }} ausgewählt)
      </h3>
      <a
          aria-controls="contentIdForA11y4"
          :aria-expanded="props.open">
          <b-icon :icon="!props.open ? 'menu-down' : 'menu-up'"></b-icon>
          {{ !props.open ? 'Module anzeigen' : 'Module verbergen' }}
      </a>
      <!-- class="mx-auto mt-8 md:flex md:flex-wrap md:space-x-2 md:mr-5" -->
    </div>
    </template>
      <div v-for="mod in moduleCategory.modules" :key="mod.name" class="">
       
        <b-collapse   
        animation="slide" :open="isOpen" class=" mt-4" >  
        <template #trigger="props" >
          <div
          class="card px-3 "
          role="button"
          aria-controls="contentIdForA11y3"
          :aria-expanded="props.open">
            <div class="card-header-title container px-2 py-2">
                      <div
                        class="shadow px-4 py-5 border-gray-800 card-header"
                        v-if="!mod.licence"
                        v-bind:class="{
                          lockedCourse: mod.licence == false,
                        }"
                        >
                          <section>
                            <b-field>
                              <b-tooltip 
                              position="is-right" 
                              multilined
                              label="Enthält Content Dritter"
                              >
                                
                                <font-awesome-icon
                            :icon="lockedIcon"
                            color="blue"
                            class="items-center"
                          />
                            </b-tooltip>   
                            </b-field>
                        </section>
                      </div>   
                      <p class="card-header-title">
                        {{ mod.name }}
                      </p>
                      <!-- <font-awesome-icon :icon="['fas', 'info']" /> -->
                      <div
                      class="container px-2 py-2"
                      >
                      <section>
                          <b-field>
                            <b-tooltip position="is-bottom" multilined>
                              <b-tag type="is-info is-light" rounded size="is-medium">CC-Lizenz</b-tag>
                              <template v-slot:content>
                                  <b>CC-Lizenzen:</b>
                                  <div v-if="mod.CC.CC_0 === '0'">CC-0</div>
                                  <div v-if="mod.CC.CC_BY === 'BY'">BY</div>
                                  <div v-if="mod.CC.CC_NC === 'NC'">NC</div>
                                  <div v-if="mod.CC.CC_ND === 'ND'">ND</div>
                                  <div v-if="mod.CC.CC_SA === 'SA'">SA</div>
                              </template>
                          </b-tooltip>
                        </b-field>
                      </section>
                    </div>
                    <div class="level-left">
                      <div class="control">
                        <b-taglist attached>
                            <b-tag type="is-dark">Shared</b-tag>
                            <b-tag type="is-success">{{ mod.sections.length }}</b-tag>
                        </b-taglist>
                      </div>
               
                    </div>
           
                  </div>
<!--                     <div class=" ">
                     <img
                        src="../assets/images/videos-1.png"
                        class="w-full h-full object-cover object-center"
                        alt="analytics"
                      />
                      <div>{{ mod.media.name }}</div>

                    </div> -->
                    <div class="px-4 py-5 ">
                        {{ mod.description }}
                      </div>
                    <div
                      class="container px-2 py-2"
                      v-if="mod.module_subcategory"
                    >
                    <b-field grouped>
                    <div v-for="module_subcategory in mod.module_subcategory" :key="module_subcategory.id" class="control mt-2">             
                        <span>                       
                            <b-tag rounded size="is-medium">{{ module_subcategory.key.key }}</b-tag>             
                        </span>
                      </div>
                    </b-field>
                    </div>
                    <a class="card-header-icon">
                      <b-icon
                      :icon="props.open ? 'menu-down' : 'menu-up'">
                    </b-icon>
                    <b-button type="is-light">
                      <a class="card-footer-item">Details</a>
                    </b-button>
                    </a>
                </div>
            </template>
            <div class="card ">
            <div class="card-content">
            <div class="content border-b-4 border-gray-800 ">
              <!-- If cc licence is true show without blue lock -->
              <div v-for="media in mod.media" :key="media.id" class="mt-2">
                  <div
                    v-if="media.mime == 'application/pdf'"
                    class="flex items-center"
                  >
                  <font-awesome-icon class="red-color" icon="fa-file-pdf" />
                    <a :href="media.url" target="_blank">&nbsp;{{
                      media.name
                    }}</a>
                  </div>
                <div class="video" v-if="media.mime == 'video/mp4'">
                    <video controls class="video-width">
                    <source 
                      :src="media.url" 
                      :type="media.mime"/>
                    Sorry, your browser doesn't support embedded videos.
                    </video>
                    <a :href="media.url" target="_blank">Alternativer Link: {{
                      media.name
                    }}</a>
                  </div>
                  <div v-if="media.mime == 'application/zip'">
                    <!-- <font-awesome-icon class="text-xl" :icon="['fa-solid', 'fa-file-zipper']" /> -->
                    <!-- <video :src="'//' + API_URL + media.url"></video> -->
                    <a :href="media.url" target="_blank">&nbsp;{{
                      media.name
                    }}</a>
                  </div>
  <!--                 <div v-if="media.mime == 'application/zip'">
                     <a :href="media.url" target="_blank">&nbsp;{{
                      media.name
                    }}</a>
                    <video :src="'//' + API_URL + media.url"></video>
                  </div> -->
                  <div v-if="media.mime == 'text/html'">
                    <a :href="media.url" target="_blank"
                      >Die Seite öffnen</a
                    >
                  </div>
              
                  <!-- <div v-if="!media.url">{{ media }}</div> -->
                  
                </div>
                <!-- iFrame URL -->
                    <div> 
                      <div v-if="mod.iFrame_URL">
                        <br>
                        <h1>Webinar</h1>
                        <div class="iframe-container">
                          <iframe :src="mod.iFrame_URL" frameborder="0" allowfullscreen></iframe>
                        </div>
                        <!-- <a :href="mod.iFrame_URL" target="_blank">{{ mod.iFrame_URL }}</a> -->
                        <b-button
                          type="is-link is-light"
                          tag="a"
                          target="_blank"
                          :href="mod.iFrame_URL"
                          icon-left="github-circle"
                          >
                          In einem neuen Fenster öffnen
                        </b-button>
                      </div>
                    </div>
                  </div>
            </div>
<!--               <footer class="card-footer">
                  <a class="card-footer-item">Hinzufügen</a>
              </footer> -->
            </div>
         
            </b-collapse>
            <div class="block">
              <b-navbar v-if="!isMobile">
                <template #start>
                  <b-navbar-item href="#">
                    <b-checkbox
                      type="is-success"
                      :id="'mod-' + mod.id"
                      :value="mod"
                      :checked="isSelected(mod)"
                      @input="toggleSelection(mod)"
                    >
                      Auswählen {{ mod.name }}
                    </b-checkbox>
                  </b-navbar-item>
                </template>
                <template #end>
                  <b-navbar-item tag="div">
                    <b-button
                      v-if="superAdmin"
                      type="is-danger"
                      size="is-small"
                      rounded
                      :id="mod.id"
                      class="bg-red-500 hover:bg-red-600 text-white ml-5 font-bold px-4 rounded-full"
                      v-on:click="confirmDeleteModule(mod)"
                      >
                      <font-awesome-icon :icon="['fas', 'trash']" />
                      Modul {{ mod.name }} löschen
                    </b-button>
                  </b-navbar-item>
                </template>
              </b-navbar>
              <br>
            </div>
          </div>
      </b-collapse>
    </section>
<!-- Modul Category END -->
</div>
      </div>
      <footer class="footer">
      <div class="content has-text-centered">
        <p>
          <strong>education Brandenburg</strong> by <a href="https://jgthms.com">OSZ Palmnicken</a>
        </p>
      </div>
    </footer>
    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          The source code is licensed
          <a href="http://opensource.org/licenses/mit-license.php">MIT</a>. The website content
          is licensed <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/">CC BY NC SA 4.0</a>.
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import gql from "graphql-tag";

import Buefy from 'buefy';
import 'buefy/dist/buefy.css'

Vue.use(Buefy);

import { library } from "@fortawesome/fontawesome-svg-core";
import { faLock } from "@fortawesome/free-solid-svg-icons";
library.add(faLock);

import Sortable from 'sortablejs'

import PdfSummarizer from '@/components/PdfSummarizer.vue'

const createSortable = (el, options, vnode) => {
      return Sortable.create(el, {
        ...options,
        onEnd: function (evt) {
            const data = vnode.componentInstance.$data.tags
            const item = data[evt.oldIndex]
            if (evt.newIndex > evt.oldIndex) {
                for (let i = evt.oldIndex; i < evt.newIndex; i++) {
                    data[i] = data[i + 1]
                }
            } else {
                for (let i = evt.oldIndex; i > evt.newIndex; i--) {
                    data[i] = data[i - 1]
                }
            }
            data[evt.newIndex] = item
            vnode.componentInstance.$emit('input', data)
            vnode.context.$buefy.toast.open(`Moved ${item} from row ${evt.oldIndex + 1} to ${evt.newIndex + 1}`)
        }
      })
    }

    /**
     * We add a new instance of Sortable when the element
     * is bound or updated, and destroy it when it's unbound.
     */
    const sortable = {
        name: 'sortable',
        bind(el, binding, vnode) {
            const container = el.querySelector('.taginput-container')
            container._sortable = createSortable(container, binding.value, vnode)
        },
        update(el, binding, vnode) {
            const container = el.querySelector('.taginput-container')
            container._sortable.destroy()
            container._sortable = createSortable(container, binding.value, vnode)
        },
        unbind(el) {
            const container = el.querySelector('.taginput-container')
            container._sortable.destroy()
        }
    }

import data from '@/store/data_tags.json'

export default {
  name: "ModulesSection",
  directives: { sortable },
  components: {
    PdfSummarizer,
  },
  props: {
    mod: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      user: JSON.parse(localStorage.getItem("user"))
        ? JSON.parse(localStorage.getItem("user"))
        : { role: { name: 0 } },
      superAdmin: false,
      switchStates: {
        CC_0: true,
        CC_BY: false,
        CC_NC: false,
        CC_ND: false,
        CC_SA: false
      },
      filteredTags: data,
      allowNew: false,
      openOnFocus: true,
      isOpenModule: null,
      formData: {
        name: '',
        description: '',
        module_category: null, // This will hold the selected module_category ID
        CC: null,
        documentation: false,
        module_subcategory: [], // Array of selected subcategories
        licence: false,
        ModuleCode: null,
        moduleCode: null,
        media: null, // This will hold the selected media ID
        sections: [],
        iFrame_URL: '',
        webinar: false
      },
      moduleCategoriesFetch: [],
      moduleCategories: [],
      mediaOptions: [],
      dropFiles: [],
      isComponentModalActive: false,
      formProps: {
          email: 'evan@you.com',
          password: 'testing'
      },
      sortableOptions: {
          chosenClass: 'is-primary',
          draggable: '.tag'
      },
      tags: [
          'Pizza',
          'Ice cream',
          'Cake'
      ],
      isOpen: 0,
      isOpenCategory: 0,
      lockedIcon: "fas fa-lock",
      API_URL:
        process.env.NODE_ENV == "production"
          ? process.env.VUE_APP_STRAPI_API_URL
          : "http://localhost:1338",
      selectedMod: [],
      stickyContainer: false,
      isWebinar: false,
      corsAnywhereUrl: 'https://info-getthekt.herokuapp.com/'
    };
  },
  computed: {
    ...mapGetters(['getSelectedMod']),

    isMobile() {
      return window.innerWidth <= 768;
    },

    filteredModuleCategories() {
      return this.moduleCategories.filter(moduleCategory => moduleCategory.name !== 'Tutorial' && moduleCategory.modules && moduleCategory.modules.length > 0);
    },
    ccValues() {
      return {
        CC_0: this.switchStates.CC_0 ? '0' : null,
        CC_BY: this.switchStates.CC_BY ? 'BY' : null,
        CC_NC: this.switchStates.CC_NC ? 'NC' : null,
        CC_ND: this.switchStates.CC_ND ? 'ND' : null,
        CC_SA: this.switchStates.CC_SA ? 'SA' : null
      };
    },
    webinarURL(){
      return this.formData.iFrame_URL
    },
    isMediaRequired() {
      return this.isWebinar;
    }
   
  },
  watch: {
    switchStates: {
      handler(newValue) {
        // Log the current state of the switches
        console.log('Switch States:', newValue);
      },
      deep: true
    },
    getSelectedMod(newMod) {
      this.selectedMod = newMod;
    },
  },
  methods: {
    ...mapActions(['updateSelectedMod']),

    fullWebinarURL(webinarURL) {
      return this.corsAnywhereUrl + webinarURL;
    },

    toggleDetails(index) {
      if (this.isOpenModule === index) {
        this.isOpenModule = null;
      } else {
        this.isOpenModule = index;
      }
    },
    getDetailButtonText(index) {
      return this.isOpenModule === index ? "Close Details" : "Mehr Details";
    },

    toggleStickyContainer() {
      this.stickyContainer = !this.stickyContainer;
    },

    isSelected(mod) {
      console.log(mod.id)
      return this.selectedMod.some(selected => selected.id === mod.id);
    },

    toggleSelection(mod) {
      // const selectedMod = [...this.getSelectedMod];
      const index = this.selectedMod.findIndex(selected => selected.id === mod.id);
      if (index === -1) {
        this.selectedMod.push(mod);
        this.showNotification(mod, true);
      } else {
        this.selectedMod.splice(index, 1);
        this.showNotification(mod, false);
      }
      this.updateSelectedMod(this.selectedMod);
    },

    showNotification(mod, added) {
      const message = added 
        ? `Modul ${mod.name} erfolgreich zur Auswahl hinzugefügt.` 
        : `Modul ${mod.name} von Auswahl entfernt.`;
        const type = added ? 'is-success' : 'is-danger';
        this.$buefy.toast.open({
          message,
          type,
          duration: 3000,
          position: 'is-bottom-right'
        });
    },

    moduleCount(moduleCategory) {
      const total = moduleCategory.modules ? moduleCategory.modules.length : 0;
      const selected = moduleCategory.modules ? moduleCategory.modules.filter(mod => this.isSelected(mod)).length : 0;
      return { total, selected };
    },

    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    getFilteredTags(text) {
        this.filteredTags = data.filter((option) => {
            return option.key
                .toString()
                .toLowerCase()
                .indexOf(text.toLowerCase()) >= 0
        })
    },
    // getSelectedCCValues() {
    //   console.log(this.ccValues)
    //   // Create a string representation of the selected CC values
    //   return JSON.stringify(this.ccValues, null, 2);
    // },
    closeModal() {
        this.isComponentModalActive = false;
    },
    deleteDropFile(index) {
            this.dropFiles.splice(index, 1);
        },
    imageModal() {
      const h = this.$createElement
      const vnode = h('p', { class: "image is-4by3" }, [
          h('img', { attrs: { src: 'https://buefy.org/static/img/placeholder-1280x960.png' }})
      ])
      this.$buefy.modal.open({
          content: [ vnode ]
      })
  },

  async createModule() {
    const token = localStorage.getItem('token'); // Adjust based on how you store your JWT
    //const iFrameUrl = this.formData.iFrame_URL
      try {
        this.formData.CC = this.ccValues;

        // if sub category is not selected use '[]'
        if (!this.formData.module_subcategory.length) {
          this.formData.module_subcategory = '[]';
        }else{
          this.formData.module_subcategory = this.module_subcategory.map((tag, index) => ({
            id: index + 1,
            key: tag
          }));
        }
          // Set the webinar URL conditionally based on the showWebinar state
          if (this.webinarURL) 
          {
            this.formData.webinar = this.isWebinar
            this.formData.iFrame_URL = this.webinarURL
            // alert(this.formData.iFrame_URL)
          } else {
            // alert("false", this.formData.iFrame_URL)
            this.formData.iFrame_URL = '';
          }

        console.log("this.formData", this.formData)
        alert("wait")
        const response = await fetch(this.API_URL + '/modules', {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(this.formData),
        });

        console.log("response", response)

        if (response.ok) {
          const data = await response.json();
          console.log('Module created:', data);
          this.closeModal();
          location.reload(this.$router.currentRoute);
        } else {
          console.error("Error Creating module:", response.statusText);
          if (response.status === 401) {
            console.error('Unauthorized access: ', response.statusText);
          }
        }
      } catch (error) {
        console.error('Error creating module:', error);
      }
    },
    confirmDeleteModule(mod) {
      this.$buefy.dialog.confirm({
        title: 'Modul löschen',
        message: `Bist du dir sicher, dass du das Modul: <b>${mod.name}</b> für immer <b>löschen</b> möchtest? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: 'Modul löschen',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.deleteModule(mod.id);
        }
      });
    },
    deleteModule(moduleId) {
      try {
        const response = this.$store.dispatch('deleteModule', moduleId);
        console.log("delete module response:", response);

        // Check if the response indicates success
        if (response && response.status !== 401) {
          location.reload(this.$router.currentRoute);
        } else {
          console.error('Failed to delete module: Unauthorized');
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          console.error('Unauthorized access: ', error);
        } else {
          console.error('Error deleting module:', error);
        }
      }
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
  async mounted() {
    const token = localStorage.getItem('token'); // Adjust based on how you store your JWT
    window.addEventListener('resize', this.checkMobile);

    try {
      if(this.user.user_permissions.some((p) => p.key === "super_admin" )){
        console.log("Dieser User hat Super_admin Kräfte")
        this.superAdmin = true
      }
      // Fetch module categories
      const categoryResponse = await fetch(this.API_URL + '/module-categories', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (categoryResponse.ok) {
        this.moduleCategoriesFetch = await categoryResponse.json();
      } else {
        console.error('Error fetching module categories:', categoryResponse.statusText);
      }

      // Fetch media options
      const mediaResponse = await fetch(this.API_URL + '/pdf-uploads', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (mediaResponse.ok) {
        this.mediaOptions = await mediaResponse.json();
      } else {
        console.error('Error fetching media options:', mediaResponse.statusText);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  apollo: {
    moduleCategories: {
      query: gql`
        query {
          moduleCategories {
            name
            modules {
              id
              name
              description
              licence
              CC
              module_subcategory
              iFrame_URL
              webinar
              sections{
                id
              }
              media {
                name
                mime
                url
              }
            }
          }
        }
      `,
    },
    // fileUpload: {
    //   query: gql`
    //   query {
    //     pdfUploads {
    //       id
    //       File {
    //         id
    //         name
    //         url
    //         mime
    //       }
    //     }
    //   }
    // `,
    // }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css");
body {
  font-family: "Lato", sans-serif;
}
.checkbox:checked {
  border: none;
}
.checkbox:checked + .check-icon {
  display: flex;
}
.lockedCourse {

}
.collapse-padding {
  padding: 3px;
}
.tag-container {
  cursor: pointer; /* Optional: Add a pointer cursor to indicate the tag is clickable */
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 10px; /* Adjust the gap value as needed */
}

.sticky-container {
  position: -webkit-sticky; /* For Safari */
  position: sticky;
  top: 5vh;
  background: white; /* Adjust background color as needed */
  z-index: 1000; /* Ensure it appears above other content */
  padding: 10px; /* Optional padding for better visual appearance */
}
.sticky-modal {
  position: -webkit-sticky; /* For Safari */
  position: sticky;
  background: white; /* Adjust background color as needed */
  z-index: 1001; /* Ensure it appears above other content */
}
.modal-card {
  width: auto;
}
.color-blue {
  color: #0047ab;
}
.red-color {
    color:red;
}
  .image {
      height: 200px;
  }
  .video {
      margin-top: 5rem;
      margin-bottom: 5rem;
  }
  .iframe-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
}

.iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
  .video-width {
      width: 100%;
  }
  
  @media (max-width: 700px) {
      .long {
          max-width: 100%;
          flex-basis: 100%;
      }
      .image {
          width: 100%;
          height: 100%;
      }
  }
</style>
